import React from 'react';
import ReactDOM from 'react-dom';
import WeatherWidget from './components/WeatherWidget';
import './weather-icons/css/weather-icons.min.css';
import './weather-icons/css/weather-icons-wind.css';

/**
 * OHT Weather Widget - React Version
 * 
 * This script initializes the React application when the DOM content is loaded.
 */

// Initialize the app when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Find all weather widget containers
  const weatherRootElements = document.querySelectorAll('[id^="weather-root-"], #weather-root');
  
  // Initialize each weather widget found
  weatherRootElements.forEach(weatherRoot => {
    if (weatherRoot) {
      // Extract data attributes from the container
      const {
        zipcode,
        location,
        showTabs,
        showTodayForecast,
        showCurrentWeather,
        showSearchBox,
        showLocation,
        showBorder,
        showAlerts,
        linkUrl,
      } = weatherRoot.dataset;

      // Parse showTabs since it's a JSON string
      const parsedShowTabs = showTabs ? JSON.parse(showTabs) : undefined;

      ReactDOM.render(
        <React.StrictMode>
          <WeatherWidget
            zipcode={zipcode}
            locationName={location}
            showTabs={parsedShowTabs}
            showTodayForecast={showTodayForecast !== '0'}
            showCurrentWeather={showCurrentWeather !== '0'}
            showSearchBox={showSearchBox !== '0'}
            showLocation={showLocation !== '0'}
            showBorder={showBorder !== '0'}
            showAlerts={showAlerts !== '0'}
            linkUrl={linkUrl}
          />
        </React.StrictMode>,
        weatherRoot
      );
    }
  });
});

// If using a build system, we can export the component
export { WeatherWidget }; 